import React, { useState } from "react";
import Axios from 'axios';
import { Link } from "react-router-dom";

const PasswordResetRequest = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      Axios.post("https://mygamename.com/php/reset_password.php", {
        email: email,
      }).then((response) => {
        setMessage(response.data.message || "Check your email for the reset link.");
        setEmail('');
      });
    } catch (error) {
      setMessage("Error sending reset email. Please try again.");
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#222222] rounded-xl p-8">
        <h1 className="text-3xl font-extrabold text-[#F5F5F5] mb-2 tracking-tight">Reset password</h1>
        <p className="text-[#F5F5F5]/50 text-sm mb-8">Enter your email and we'll send you a reset link.</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 placeholder-[#F5F5F5]/30 outline-none transition-colors"
            required
          />
          {message && (
            <p className="text-sm text-[#F5F5F5] rounded-lg bg-[#111111] border border-[#8B5CF6]/40 p-3">
              <span className="font-medium text-[#8B5CF6]">Done!</span> {message}
            </p>
          )}
          <button
            type="submit"
            className="w-full bg-[#8B5CF6] hover:bg-[#7C3AED] text-[#F5F5F5] font-semibold py-3 rounded-lg transition-colors mt-2"
          >
            Send Link
          </button>
        </form>

        <p className="text-center text-[#F5F5F5]/50 text-sm mt-6">
          Remember your password?{' '}
          <Link to="/login" className="text-[#8B5CF6] hover:text-[#7C3AED] font-semibold transition-colors">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default PasswordResetRequest;
